import React, { useCallback } from 'react';

import { useCollabInvitesAsNotificationsEnabled } from '@editor/global/growthbookUtils';
import { CollaborationInviteNotificationData } from '@editor/types';
import { useTranslation } from '@repo/i18n';
import { Button } from '@repo/ui-kit/components/core/Button';
import { P4 } from '@repo/ui-kit/components/core/Typography';

import NotificationHeader from '../NotificationHeader/NotificationHeader';

import {
  NotificationWrapper,
  CollaborationInviteButtonWrapper,
} from './styles';
import { NotificationProps } from './types';

const CollaborationInviteNotification: React.FC<
  NotificationProps<CollaborationInviteNotificationData>
> = ({ notification, handleDeleteNotification }) => {
  const invitesAsNotificationsEnabled =
    useCollabInvitesAsNotificationsEnabled();
  const { shareLink } = notification.data;

  const acceptClick = useCallback((): void => {
    const acceptUrl = new URL(shareLink);

    handleDeleteNotification(notification.id);

    window.open(acceptUrl, '_blank', 'noopener')?.focus();
  }, [handleDeleteNotification, notification.id, shareLink]);

  const declineClick = useCallback((): void => {
    handleDeleteNotification(notification.id);
  }, [handleDeleteNotification, notification.id]);

  const { t } = useTranslation('collab');

  if (!invitesAsNotificationsEnabled) {
    return null;
  }
  return (
    <NotificationWrapper disableHover>
      <NotificationHeader
        createdAt={notification.createdAt}
        isUnseen={!notification.seenAt}
        message={
          <P4 color="secondary">
            Invited you to{' '}
            <P4 bold as="span">
              {notification.data.projectName}
            </P4>
          </P4>
        }
        user={notification.relatedUser}
      />
      <CollaborationInviteButtonWrapper>
        <Button
          name="collaborationNotificationAccept"
          size="xs"
          variant="primary"
          onClick={acceptClick}
        >
          <Button.Label>{t('share.access.notification_accept')}</Button.Label>
        </Button>
        <Button
          name="collaborationNotificationDecline"
          size="xs"
          variant="secondary"
          onClick={declineClick}
        >
          <Button.Label>{t('share.access.notification_decline')}</Button.Label>
        </Button>
      </CollaborationInviteButtonWrapper>
    </NotificationWrapper>
  );
};

export default CollaborationInviteNotification;
